export default "/images/copy-app.png?f69382a8ab33bff915ebe87234f08217";